import { IConversationMessage } from '@/utils/conversation/types';

interface IChatEstimatorOptions {
  baseHeight: number;
  basePadding: number;
  headerHeight: number;
  actionsHeight: number;
  replyOffset: number;
}

type EstimateVirtualItemHeightFn = (message: IConversationMessage, estimatorOptions?: IChatEstimatorOptions) => number;

const defaultEstimatorOptions = {
  charactersPerRow: 50,
  textRowHeight: 22,
  baseHeight: 30,
  basePadding: 15,
  headerHeight: 15,
  actionsHeight: 25,
  replyOffset: 27,
};

export const estimateVritualItemHeight: EstimateVirtualItemHeightFn = (message, estimatorOptions) => {
  const { charactersPerRow, textRowHeight, baseHeight, basePadding, headerHeight, actionsHeight, replyOffset } = {
    ...defaultEstimatorOptions,
    ...estimatorOptions,
  };

  const replyHeight = message?.attributes?.parentMessageId ? 0 : replyOffset;

  const bodyHeight = (() => {
    const paragraphs = message.body.split(/\r\n|\r|\n/);

    const lines = paragraphs.reduce((acc: number, paragraph: string) => {
      // empty lines will be "", we need to count them as a full line
      const paragraphLength = paragraph.length || 1;
      const baseLines = Math.ceil(paragraphLength / charactersPerRow);

      return acc + baseLines;
    }, 0);

    return lines * textRowHeight;
  })();

  return baseHeight + basePadding + headerHeight + replyHeight + actionsHeight + bodyHeight;
};

export const getVisibleMessageSids = (visibleIndexes: Array<string>, messages: Array<IConversationMessage>) => {
  if (!messages?.length) return [];

  return visibleIndexes?.map((virtualIndex) => {
    const message = messages[virtualIndex];

    // if a message reply is visible,
    // regardless of whether the parent message is visible
    // we still want to subscribe to its updates
    return message.attributes.parentMessageId || message.sid;
  });
};
